var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcrDocumentOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12041_168169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12041_168169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29905 18.5004H14.693C14.9477 18.5004 15.1625 18.4147 15.3375 18.2432C15.5125 18.0717 15.6 17.8592 15.6 17.6057C15.6 17.3522 15.5139 17.1379 15.3416 16.9629C15.1693 16.7879 14.9558 16.7004 14.701 16.7004H9.30712C9.05241 16.7004 8.83755 16.7861 8.66255 16.9576C8.48755 17.1291 8.40005 17.3416 8.40005 17.5951C8.40005 17.8486 8.4862 18.0629 8.6585 18.2379C8.83082 18.4129 9.04433 18.5004 9.29905 18.5004ZM9.29905 14.9004H14.693C14.9477 14.9004 15.1625 14.8147 15.3375 14.6432C15.5125 14.4717 15.6 14.2592 15.6 14.0057C15.6 13.7522 15.5139 13.5379 15.3416 13.3629C15.1693 13.1879 14.9558 13.1004 14.701 13.1004H9.30712C9.05241 13.1004 8.83755 13.1861 8.66255 13.3576C8.48755 13.5291 8.40005 13.7416 8.40005 13.9951C8.40005 14.2486 8.4862 14.4629 8.6585 14.6379C8.83082 14.8129 9.04433 14.9004 9.29905 14.9004ZM6.59297 22.1004C6.09769 22.1004 5.67505 21.9241 5.32505 21.5716C4.97505 21.2191 4.80005 20.7954 4.80005 20.3004V4.70039C4.80005 4.20539 4.9763 3.78164 5.3288 3.42914C5.6813 3.07664 6.10505 2.90039 6.60005 2.90039H13.65C13.8871 2.90039 14.113 2.94206 14.3278 3.02539C14.5426 3.10872 14.7417 3.24206 14.925 3.42539L18.675 7.17539C18.8584 7.35872 18.9917 7.5578 19.0751 7.77262C19.1584 7.98743 19.2 8.21336 19.2 8.45039V20.3004C19.2 20.7954 19.0237 21.2191 18.671 21.5716C18.3183 21.9241 17.8943 22.1004 17.3991 22.1004H6.59297ZM13.2 8.00039V4.70039H6.60005V20.3004H17.4V8.90039H14.1C13.845 8.90039 13.6313 8.81414 13.4588 8.64164C13.2863 8.46914 13.2 8.25539 13.2 8.00039Z",
    fill: "#E67300"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrDocumentOrange);
export default __webpack_public_path__ + "static/media/ocr-document-orange.0f871d8ef5cdf8d31cc527b64850c2e4.svg";
export { ForwardRef as ReactComponent };